import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Calendar } from 'core-lib';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
@Component({
    selector: 'app-attendees-export-form',
    templateUrl: './attendees-export-form.component.html',
    styleUrls: ['./attendees-export-form.component.scss'],
    standalone: false
})
export class AttendeesExportForm implements OnInit {

    attendeesExportForm: FormGroup;
    calendar: Calendar;

    constructor(private dialogRef: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {
        this.calendar = dialogConfig.data?.calendar;
    }


    ngOnInit(): void {

        this.attendeesExportForm = new FormGroup({
            startDate: new FormControl(null,[Validators.required]),
            endDate: new FormControl(null,[Validators.required]),
            createWorksheets: new FormControl(true),
        });
    };

    onAccept(): void {
        const data = {startDate: this.attendeesExportForm.get('startDate').value, endDate: this.attendeesExportForm.get('endDate').value, createWorksheets : this.attendeesExportForm.get('createWorksheets').value}
        this.dialogRef.close(data);
    }
}
